import MicroModal from 'micromodal';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({className: 'c-rte'})
export class LetsTalkRTEComponent {
	constructor(private element: HTMLElement) {
		const triggers = Array.from(this.element.querySelectorAll<HTMLElement>('[href=\'#lets-talk\']'));
		triggers.forEach(trigger => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				MicroModal.show('modal-lets-talk', {
					disableFocus: false,
					awaitOpenAnimation: true,
					awaitCloseAnimation: true,
				});
			});
		});
	}
}
